import React, { useEffect, useState, useRef } from "react"
import { useLocation } from "react-router-dom"
import { styled, keyframes } from "../stitches.config";
import { observer } from "mobx-react"
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Cookies from "cookies-js";

import Link from "./Link"
import Adslot from "./Adslot"

import { isInvalidUser } from "./HOCs/isInvalidUser"
import { useStores, useInterval, useTimeout, pushDataLayer } from "../helpers"

import { IS_COMMERCIALBREAK_DISABLE_TIMEOUT } from './common/constants/constants.js';

/*

    Zasada działania:
    1. reklama spawnuje się po pierwszym klikniciu na z-index -1 
    2. jeśli reklama się wypełniła - zmieniamy z-index na maksymalny
    3. po przekliknięciu/timeoucie zakładamy flagę, ze reklama została juz raz zamknięta
    4. jeśli reklama się nie wypełniła - symulujemy klik/timeout i zwracamy nulla z komponentu

*/

const SLOT_NAME = "layer_1x1"

const CommercialBreakOverlay = observer(() => {
    const { AdsStore, UIStore } = useStores();
    const location = useLocation();

    const urlParams = new URLSearchParams(location.search);

    const isSandbox = urlParams.get('commercialBreakSandbox') !== null;

    const [isRedirectButtonDisabled, setIsRedirectButtonDisabled] = useState(IS_COMMERCIALBREAK_DISABLE_TIMEOUT);

    //Analityka
    const spawnTime = useRef(-1);
    const onloadTime = useRef(-1);
    const impressionTime = useRef(-1);

    /**
     * czy podczas tej wizyty mam próbować wyrenderować commercial break (próbujemy tylko raz na wizyte, chyba że sandbox)
     */
    const [capped, setCapped] = useState(!isSandbox);

    /**
     * czy nie pojawiła sie reklama?
     * @todo zmienić na "zwykłą" logike, a nie "odwrotną"
     */
    const [isEmpty, setIsEmpty] = useState(true);

    /**
     * czy próbować wstawić overlay w body strony
     */
    const [overlaySpawned, setOverlaySpawned] = useState(false);

    /**
     * timery:
     * count - od kiedy człowiek może zamknąć ekran (aktualnie nieużywane)
     * redirectTimer - odliczanie do wyłączenia commercial breaka
     */
    const [count, setCount] = useState(5);
    const [redirectTimer, setRedirectTimer] = useState(15);

    /**
     * 
     */
    const ref = useRef();

    /**
     * user zamknął commercial break
     */
    const wasClicked = useRef(false);

    /**
     * wyłącz ekran commercial-breaka (robi to user buttonem, albo automatycznie po redirectTime sekundach)
     */
    const handleClick = () => {
        setOverlaySpawned(false)
        clearAllBodyScrollLocks()

        //Analityka
        const loadTime = onloadTime.current >= 0 ? Math.round((onloadTime.current - spawnTime.current) / 1000) : -1;
        const imTime = impressionTime.current >= 0 ? Math.round((impressionTime.current - spawnTime.current) / 1000) : -1;
        const closeTime = Math.round((Date.now() - spawnTime.current) / 1000);
        if (!wasClicked.current) {
            console.log('[ES] CommercialBreak',
                `load: ${loadTime}`,
                `close: ${closeTime}`,
                `impression: ${imTime}`,
            );

            pushDataLayer({
                event: "analyticsEvent",
                eventCategory: "Commercial_break_view",
                eventAction: `l:${loadTime} i:${imTime} c:${closeTime}`,
                eventValue: undefined
            });
        }

        wasClicked.current = true;
        // if (window.scrollY > 0) {
        //     window.scrollTo(0, 0)
        // }
    }

    // const refreshAdslot = () => {
    //     const { pbjs = {}, googletag, AD_SLOTS = {} } = window;
    //     pbjs.que.push(() => {
    //         pbjs.requestBids({
    //             adUnitCodes: [SLOT_NAME],
    //             bidsBackHandler: () => {
    //                 pbjs.setTargetingForGPTAsync([SLOT_NAME]);
    //                 googletag.cmd.push(() => googletag.pubads().refresh([AD_SLOTS[SLOT_NAME]]));
    //             },
    //         })
    //     });
    // }

    /**
     * podpięcie listenera pod wyrenderowanie się reklamy wewnątrz commercial-break
     */
    useEffect(() => {
        console.log('[ES] CommercialBreakOverlay::useEffect []');

        const cookie = Cookies.get(SLOT_NAME);
        const hasCookie = typeof cookie === "string";

        /* Uruchamiam zawsze w sandbox */
        if (!hasCookie || isSandbox) {
            !isSandbox && setCapped(false);

            const { googletag } = window;
            googletag.cmd.push(() => {
                googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                    const slotId = event.slot.getSlotElementId()
                    if (slotId === SLOT_NAME) {
                        // console.log({ isEmpty: event.isEmpty })
                        const styles = "color: white; background-color: green; font-size: bold;"
                        console.group('Slot', event.slot.getSlotElementId(), 'finished rendering.',);
                        console.log('%cAdvertiser ID:', styles, event.advertiserId);
                        console.log('%cCampaign ID: ', styles, event.campaignId);
                        console.log('%cCreative ID: ', styles, event.creativeId);
                        console.log('%cisEmpty:', styles, event.isEmpty);
                        console.log('%cLine Item ID:', styles, event.lineItemId);
                        console.log('%cSize:', styles, event.size);
                        console.log('%cSource Agnostic Creative ID:', styles, event.sourceAgnosticCreativeId);
                        console.log('%cSource Agnostic Line Item ID:', styles, event.sourceAgnosticLineItemId);
                        console.groupEnd();
                        if (!event.isEmpty) {
                            disableBodyScroll(ref.current);
                            setIsEmpty(false);

                            //Analityka
                            spawnTime.current = Date.now();
                            impressionTime.current = -1;
                            onloadTime.current = Date.now(); //Onload dla elementów, które są ładowane "in sync rendering mode"

                            // capping tylko w przypadku, kiedy reklama nie jest pusta 
                            const d = new Date()
                            d.setMinutes(d.getMinutes() + AdsStore.adConfig[SLOT_NAME]?.capping?.time);

                            /* Jak sandbox to nie daje ciastka */
                            if (!isSandbox && !document.cookie.split(';').some((item) => item.trim().startsWith(SLOT_NAME))) {
                                document.cookie = SLOT_NAME + "=true; path=/; expires=" + d.toUTCString() + "; secure; samesite=lax";
                            }
                        } else {
                            setOverlaySpawned(false)
                        }
                    }
                });

                //Odblokuj przycisk, jeżeli zliczony Views
                googletag.pubads().addEventListener('impressionViewable', (event) => {
                    const slotId = event.slot.getSlotElementId();
                    if (slotId === SLOT_NAME) {
                        setIsRedirectButtonDisabled(false);

                        impressionTime.current = Date.now();
                    }
                });

                googletag.pubads().addEventListener('slotOnload', (event) => {
                    const slotId = event.slot.getSlotElementId()
                    if (slotId === SLOT_NAME) {
                        onloadTime.current = Date.now();
                    }
                })

                // googletag.pubads().addEventListener('slotRequested', (event) => {
                //     const slotId = event.slot.getSlotElementId()
                //     if (slotId === SLOT_NAME) {
                //         console.log({ slot_requested: true })
                //     }
                // })

                // googletag.pubads().addEventListener('slotResponseReceived', (event) => {
                //     const slotId = event.slot.getSlotElementId()
                //     if (slotId === SLOT_NAME) {
                //         console.log({ slot_response_received: true })
                //     }
                // })
            })
        }
    }, [])

    /**
     * observer wywoływany przy przejściu między stronami
     */
    useEffect(() => {
        console.log('[ES] CommercialBreakOverlay::useEffect new user interaction', overlaySpawned, wasClicked, UIStore.numberOfUserInteractions);

        //Ignore first view chyba, że sandbox
        if (UIStore.numberOfUserInteractions == 0 && !isSandbox)
            return;

        // user zamknął commercial break'a, chyba że sandbox
        if (wasClicked.current && !isSandbox) {
            return;
        }

        if (!overlaySpawned) {
            console.log("[ES] CommercialBreakOverlay::useEffect spawning commercial break")
            setOverlaySpawned(true);
            //Na pewno odblokuj przycisk po 5s
            setTimeout(() => setIsRedirectButtonDisabled(false), 5000);
        };

    }, [UIStore.numberOfUserInteractions])


    useInterval(() => {
        setCount(prev => prev - 1)
    }, !!count && !isEmpty && 1000)

    useInterval(() => {
        setRedirectTimer(rt => rt - 1)
    }, !!redirectTimer && !isEmpty && 1000)

    // useTimeout(() => {
    //     setIsRedirectButtonDisabled(false)
    // }, !isEmpty && 5000)

    /**
     * automatyczne zamykanie commercial-breaka, po redirectTimer sekundach
     */
    useTimeout(() => {
        handleClick();
    }, !isEmpty && redirectTimer * 1000)

    if (!overlaySpawned || capped) return null

    return <Overlay ref={ref} isEmpty={isEmpty} className="commbreak">
        <BarWrap>
            <Bar>
                <span>
                    REKLAMA: Automatycznie wyświetlimy artykuł za {redirectTimer}s
                </span>
                <SkipAdButton
                    // to={AdsStore.commercialBreak.redirect.to}
                    // state={AdsStore.commercialBreak.redirect.state}
                    onClick={!isRedirectButtonDisabled && handleClick}
                    disabled={isRedirectButtonDisabled}
                >
                    Przejdź do strony
                    {/* {count > 0 && `za ${count}s`} */}
                </SkipAdButton>
            </Bar>
        </BarWrap>
        <CenterAd>
            <Adslot name={SLOT_NAME} />
        </CenterAd>
    </Overlay>

})

const progress = keyframes({
    "from": {
        width: "0"
    }, "to": {
        width: "100%"
    }
});

const SafariRerenderFix = keyframes({
    'from': {
        top: '0px'
    },
    'to': {
        top: '0.01px'
    }
});

const CenterAd = styled("div", {
    display: "grid",
    placeItems: "center",
    height: "100%",
    position: "relative",
    zIndex: 100
});

const SkipAdButton = styled("button", {
    display: "block",
    minWidth: "160px",
    padding: "10px 12px",
    textAlign: "center",
    margin: "10px 20px",
    borderRadius: "5px",
    fontSize: "12px",
    backgroundColor: "#ffffff",
    color: "$primary",
    border: "2px solid",
    bordercolor: "$primary",
    transition: "all 300ms ease-out",
    zIndex: 2,
    variants: {
        disabled: {
            true: {
                borderColor: '$grayscale50',
                color: '$grayscale50',
                userSelect: 'none'
            },
            false: {}
        }
    }
});

const BarWrap = styled("div", {
    position: "absolute",
    top: "0",
    left: "0",
    right: "0",
    zIndex: 200
});

const Bar = styled("div", {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    borderBottom: "1px solid #e3e3e3",
    boxShadow: "0 -3px 10px 5px rgba(0, 0, 0, 0.2)",
    backgroundColor: "#fff",
    position: "relative",
    span: {
        display: "inline-block",
        marginLeft: "15px",
        fontSize: "12px",
        color: "#666",
        zIndex: 2
    },
    "&:before": {
        content: "",
        position: "absolute",
        top: "0",
        bottom: "0",
        left: "0",
        backgroundColor: "#e8e8e8",
        animation: `${progress} 15s linear`,
        animationFillMode: "forwards"
    }
});

const Overlay = styled("div", {
    position: "fixed",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: 2147483646,
    opacity: 1,
    pointerEvents: "auto",
    backgroundColor: "#efefef",
    "#commercial_break": {
        margin: "20px auto"
    },
    /* Wymagane, z powodu błędów w #6405 - rozwiązanie na podstawie - https://stackoverflow.com/a/43172929 */
    'iframe': {
        position: 'relative',
        clipPath: 'inset(0)',
        clip: 'unset',
        animation: `${SafariRerenderFix} 0.1s infinite`,
    },
    variants: {
        "isEmpty": {
            true: {
                zIndex: -1,
                opacity: 0,
                /* #5835 może się zdarzyć tak, że adslot jest wyłączony, to wtedy się nigdy nie odspawnuje */
                pointerEvents: "none"
            },
            false: {}
        }
    }
});

export default isInvalidUser(CommercialBreakOverlay)